'use client'

import { useAppSelector, useAppDispatch } from '@/src/store/hooks'
import {
    getErrorState,
    clearError
} from '@/src/store/slices/errorHandlingSlice'
import ErrorModal from '../errorModal'
import { useEffect, useState } from 'react'
import { DESKTOP, MOBILE } from '@/src/constants'
import { DeviceType } from '@/src/types'

const ErrorHandler = ({
    deviceType: propDeviceType
}: { deviceType?: DeviceType } = {}) => {
    const dispatch = useAppDispatch()
    const { isError, errorDetails } = useAppSelector(getErrorState)

    // Show modal for all errors now, not just specific ones
    const showErrorModal = isError

    const [deviceType, setDeviceType] = useState<DeviceType>(
        propDeviceType || (DESKTOP as DeviceType)
    )

    useEffect(() => {
        // Detect device type
        const handleResize = () => {
            setDeviceType(
                window.innerWidth > 768
                    ? (DESKTOP as DeviceType)
                    : (MOBILE as DeviceType)
            )
        }

        if (!propDeviceType) {
            handleResize()
            window.addEventListener('resize', handleResize)
            return () => window.removeEventListener('resize', handleResize)
        }
    }, [propDeviceType])

    const handleCloseErrorModal = () => {
        dispatch(clearError())
    }

    return showErrorModal ? (
        <ErrorModal
            isOpen={showErrorModal}
            onClose={handleCloseErrorModal}
            error={errorDetails}
            deviceType={deviceType}
        />
    ) : null
}

export default ErrorHandler
